import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

interface WorkspaceParams {
  name: string;
  description: string;
}

export interface WorkspaceProps {
  name: string;
  description?: string;
}

interface WorkspaceResponse {
  workspace: {
    id: string;
    name: string;
    description: string;
    user_id: string;
    status: string;
    created_at: string;
    updated_at: string;
  };
}

// Workspace 嵌套类
class WorkspaceInfo {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;
}

// 主数据类
export class WorkspaceData {
  @Required("Workspace cannot be empty")
  @ValidateNested(WorkspaceInfo)
  workspace: WorkspaceInfo;
}

const transformAndValidateWorkspace = (
  response: WorkspaceResponse
): WorkspaceData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, WorkspaceData);
  } catch (error) {
    console.error("Workspace data validation failed:", error.message);
    throw error;
  }
};

export async function workspace(props: WorkspaceProps): Promise<WorkspaceData> {
  const params: WorkspaceParams = {
    name: props.name,
    description: props.description || "",
  };
  const res = await api.post<WorkspaceResponse>("/workspace", params);
  const validatedData = transformAndValidateWorkspace(res.data);
  return validatedData;
}
